import { t } from "@lingui/core/macro";

import { getNounOverride } from "@whoosh/utilities/src/FormatNounOverride/getNounOverride";
import type { NounOverrideFields } from "@whoosh/utilities/src/FormatNounOverride/getNounOverride";

type FacilityPlayerCopyOverrides = {
  readonly lessonPlayer?: NounOverrideFields;
  readonly bookingPlayer?: NounOverrideFields;
} | null;

type GetBookingPlayerNounInput = {
  bookingType?: string | null;
  copyOverrides?: FacilityPlayerCopyOverrides;
  lowercaseFirstLetter?: boolean;
};

export const getBookingPlayerNoun = ({
  bookingType,
  copyOverrides,
  lowercaseFirstLetter = false,
}: GetBookingPlayerNounInput) => {
  const nounOverride =
    bookingType === "LessonBooking" || bookingType === "Lesson"
      ? copyOverrides?.lessonPlayer
      : copyOverrides?.bookingPlayer;

  return {
    singular: getNounOverride(
      nounOverride?.singular,
      t`player`,
      lowercaseFirstLetter
    ),
    plural: getNounOverride(
      nounOverride?.plural,
      t`players`,
      lowercaseFirstLetter
    ),
  };
};
